import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const addToQueueVideo = (data) => {
  return apiRequestType(
    apiTypes.PUT,
    apiConstants.MANAGE.ADD_TO_QUEUE_VIDEO,
    data
  );
};

export default addToQueueVideo;
